<template>
    <div>
        <!-- <Balance ref="Balance" :hide_ts="1"></Balance> -->
        <div style="display: flex;justify-content:space-between;margin-top: 10px;">
            <div style="width: auto;display: flex;">
                <el-input size="small" placeholder="ID/名称" clearable v-model="find_value"
                    @keyup.enter.native="get_list(); page = 1" @clear="get_list(); page = 1"></el-input>
                <el-button size="small" type="primary" style="margin-left: 5px;"
                    @click="get_list(); page = 1">查找</el-button>
            </div>
            <!-- <el-button type="primary" size="small" @click="add_show = true; add_item = {}">+ 新建</el-button> -->
        </div>
        <div style="margin-top: 10px;padding: 0px 5px;">
            <el-tabs v-model="class_check" @tab-click="check_type">
                <el-tab-pane v-for="item in class_list" :label="item.name" :name="item.name" :key="item.name"></el-tab-pane>
            </el-tabs>
        </div>
        <div>
            <el-row :gutter="14" >
                <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="3" v-for="(item, index) in video_list" :key="index"
                    style="margin-bottom: 7px;">
                    <div style="background-color: #fff;border-radius: 5px;" class="show-hide">

                        <div style="position: relative;" @click="make_show = true; make_item = item">
                            <el-image style="width: 100%;height: 11.4rem;border-radius: 5px 5px 0px 0px;" fit="cover"
                                :src="item.cover"></el-image>
                            <div class="tree_other">
                                <div style="text-align: center;">
                                    <i class="el-icon-scissors" style="font-size:30px;color: #fff;"></i>
                                    <div style="color: #fff;font-size: 14px;font-weight: 600;">立即制作</div>
                                </div>
                            </div>
                        </div>

                        <div style="font-size: 0.8rem;padding: 1px 5px 10px 5px;">
                            {{ item.name }}
                            <div style="margin-top: 7px;font-size: 11px;">
                                <el-tag size="mini">已涨粉:{{ item.zf }}</el-tag>
                            </div>
                        </div>

                    </div>

                </el-col>
            </el-row>
        </div>
        <div v-if="video_list.length == 0" style="display: flex;justify-content: center;">
            <el-empty description="这里空空如也"></el-empty>
        </div>
        <div v-else style="margin-top: 10px;padding-bottom: 30px;">
            <el-pagination background layout="total,prev, pager, next" :page-size="18" :total="list_total"
                @current-change="fy_page" :current-page="page">
            </el-pagination>
        </div>

        <el-dialog title="立即制作" :visible.sync="make_show" custom-class="newdialog_share" top="10%">
            <div style="display: flex;">
                <el-image style="width: 80px;height: 130px;border-radius: 5px;" fit="cover"
                    :src="make_item.cover"></el-image>
                <div style="margin-left: 10px;">
                    <div style="font-size: 17px;">
                        {{ make_item.name }}
                    </div>
                    <div style="font-size: 13px;margin-top: 5px;margin-right: 10px;">
                        单个费用: 2分钟1点
                    </div>

                </div>
            </div>
            <div class="biaoqian">制作设置</div>
            <div style="margin-top: 10px;display: flex;align-items: center;justify-content: space-between;">
                <div>
                    制作数量
                </div>
                <el-input-number size="mini" v-model="make_num" style="margin-left: 10px;" :min="1"
                    :max="10"></el-input-number>
            </div>
            <div style="display: flex;justify-content: end;align-items: center;margin-top: 30px;">

                <el-button type="primary" size="medium" @click="make_fc">立即制作</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Balance from './Balance.vue';
export default {
    name: '',
    components: {
        Balance
    },
    // 定义属性
    data() {
        return {
            page: 1,
            class_check: '全部',
            find_value: '',
            class_list: [],
            gg: '',
            list_total: 0,
            video_list: [],
            make_show: false,
            make_item: [],
            make_num: 1
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        make_fc() {
            const loading = this.$loading(this.$loadinginfo);
            var data=this.make_item
            data['xgcs']=this.make_num
            this.$ajax.post('/qhy/sck/make_video', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.make_show = false
                    this.make_num = 1
                    this.make_item = []
                    // this.$msg.success(res.data.msg)
                    // this.$refs.Balance.get_user()
                    this.$parent.$parent.$parent.$parent.get_balance()
                } else {
                    // this.$msg.error(res.data.msg)
                }
                this.$toast.show(res.data.msg,3000);
                loading.close();
            })
        },
        fy_page(e) {
            this.page = e
            this.get_list()
        },
        check_type(tab) {
            console.log(tab.name)
            this.page = 1
            this.class_check = tab.name
            this.get_list()
        },
        get_list() {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post('/qhy/sck/share_list?page=' + this.page + '&type=' + this.class_check + '&find=' + this.find_value,
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.data.status == 200) {
                        // console.log(index)
                        this.video_list = res.data.data.data
                        this.list_total = res.data.data.total
                    } else {
                        this.$msg.error('异常')
                    }
                    loading.close();
                })
        },
        class_fc() {
            var that = this
            this.$ajax.post('/qhy/sck/class_list',
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    if (res.status == 200) {
                        // uni.$u.toast(res.msg)
                        that.class_list = res.data.data
                        that.gg = res.gg
                        that.class_list.unshift({ 'id': 0, 'name': '全部' });
                    } else {
                        that.$msg.error(res.data.msg)
                    }

                })
        }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.get_list()
        this.class_fc()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.show-hide:hover .tree_other {
    display: flex;

}

.tree_other {
    display: none;

    position: absolute;
    bottom: 4px;
    top: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 25%);
    border-radius: 5px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/User/Qihao.vue


// WEBPACK FOOTER //
// src/components/User/Qihao.vue